import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { IoIosThumbsUp } from "react-icons/io";
import { IoArrowBack } from "react-icons/io5";
import { MdUnsubscribe, MdViewStream } from "react-icons/md";
import ModalImage from "react-modal-image";
import { useNavigate } from "react-router-dom";
import DashboardCard from "../../Components/Cards/DashboardCard";
import { SubTitle } from "../../Components/CustomComponents";
import LoadingButton from "../../Components/CustomComponents/LoadingButton";
import SubscribersBox from "../../Components/Subscribers";
import Table from "../../Components/Table/Table";
import ThemeChart from "../../Components/ThemeChart";
import { chartData, chartOptionsCreator } from "../../constants";
import {
  useGetCreatorAnalyticsQuery,
  useGetCreatorPricingPlanByIdQuery,
  useGetCreatorSubscriberQuery,
} from "../../Data/services/userApi";
import { ROUTES } from "./Route";
import styles from "./styles/user_management.module.scss";

const CretorDetail = ({ setPage, editedData, setEditedData }) => {
  const [updatedData, setupdatedData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [currentPage, setCurrentPage] = useState(1); // todo
  const [rowData, setRowData] = useState([]);

  const navigate = useNavigate();
  let bg1 = "#FF2E2E";
  let bg2 = "#FF0000";
  let iconColor = "rgba(249, 35, 35, 1)";
  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetCreatorAnalyticsQuery(editedData?.id, {
      refetchOnMountOrArgChange: true,
    });
  const {
    data: dataPricingPlan,
    isLoading: PricingLoading,
    isFetching: PricingFetching,
    refetch: refetchPricingPlan,
  } = useGetCreatorPricingPlanByIdQuery(
    { user_id: editedData?.id },
    {
      refetchOnMountOrArgChange: true,
    },
  );
  const {
    data: dataSubscriber,
    isLoading: subscriberLoading,
    isFetching: subscriberFetching,
    refetch: refetchSubscriberPlan,
  } = useGetCreatorSubscriberQuery(
    { creator_id: editedData?.id },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  console.log(dataSubscriber, "dataSubscriber");

  const getMonthName = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("default", { month: "short" });
  };
  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }
  useEffect(() => {
    const updatedData = [];
    chartData.labels.forEach((month) => {
      const dataForMonth = data?.data?.monthly_revenue_data?.find(
        (item) => getMonthName(item.month) === month,
      );
      updatedData.push(dataForMonth ? dataForMonth.total_revenue : 0);
    });
    setupdatedData(updatedData);
  }, [data]);

  useEffect(() => {
    if (dataSubscriber) {
      // console.log(data);
      setPageSize(dataSubscriber?.links?.per_page);
      setCurrentPage(dataSubscriber?.links?.current);
      setTotalRecords(dataSubscriber?.links?.total_records);
      setTotalPages(dataSubscriber?.links?.total);
      setRowData(dataSubscriber?.data);
    }
    if (dataSubscriber?.data?.length == 0) {
      setIndicationMessage("No Data available");
    }
  }, [dataSubscriber]);

  const cardData = [
    {
      icon: <MdUnsubscribe color={iconColor} />,
      number: isLoading ? (
        <LoadingButton />
      ) : (
        data?.data?.month_subscribers_increase
      ),
      text: "Monthly Subscribers",
    },
    {
      icon: <IoIosThumbsUp color={iconColor} />,
      number: isLoading ? <LoadingButton /> : data?.data?.monthly_likes,
      text: "Monthly Likes",
    },
    {
      icon: <MdViewStream color={iconColor} />,
      number: isLoading ? <LoadingButton /> : data?.data?.monthly_views,
      text: "Monthly Views",
    },
  ];

  const formatInstanceType = (type) =>
    type?.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()) ??
    "Attachment";

  const attachmentColumns = [
    {
      dataField: "media_url",
      text: "Image",
      headerStyle: {
        width: "150px",
      },
      formatter: (_, row) => {
        if (row?.media_type === "video") {
          return (
            <video width="120" height="90" controls>
              <source src={row?.media_url} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          );
        }

        return (
          <ModalImage
            small={row?.media_url || "/images/placeholder.png"}
            large={row?.media_url || "/images/placeholder.png"}
            alt={formatInstanceType(row?.instance_type)}
            className="height-modal-image"
          />
        );
      },
    },
    {
      dataField: "instance_type",
      text: "Type",
      sort: false,
      headerStyle: {
        width: "200px",
      },
      formatter: (_, row) => formatInstanceType(row?.instance_type),
    },
    {
      dataField: "media_type",
      text: "Media Type",
      sort: false,
      headerStyle: {
        width: "150px",
      },
      formatter: (_, row) => row?.media_type,
    },
  ];

  const columns = [
    {
      dataField: "profileImage",
      text: "Image",
      headerStyle: {
        width: "100px",
        height: "100px",
      },
      formatter: (cellContent, row) => {
        return (
          <ModalImage
            small={
              row?.user?.image_url
                ? row?.user?.image_url
                : "/images/placeholder.png"
            }
            large={
              row?.user?.image_url
                ? row?.user?.image_url
                : "/images/placeholder.png"
            }
            alt=""
            className="height-modal-image"
          />
        );
      },
    },
    {
      dataField: "username",
      text: "Name",
      sort: false,
      headerStyle: {
        width: "200px",
      },
      formatter: (_, row) => {
        return `${row?.user?.firstname} ${row?.user?.lastname}`;
      },
    },
  ];
  return (
    <div className={styles.CretorDetail}>
      <IoArrowBack
        color="white"
        size={30}
        className="cursor-pointer"
        onClick={() => {
          setPage(ROUTES.USER_MANAGEMENT);
          setEditedData(null);
        }}
      />
      <Row className={`${styles.matchRow} w-100 mt-2 mb-5`}>
        {cardData.map((card, index) => (
          <Col key={index} className="mt-2 mb-2" lg={4} md={4} sm={6}>
            <DashboardCard
              bg1={bg1}
              bg2={bg2}
              icon={card.icon}
              number={card.number}
              text={card.text}
            />
          </Col>
        ))}
      </Row>
      <Row>
        <Col md={12}>
          <div className={"themeChart"}>
            <ThemeChart
              type="line"
              data={updatedData}
              chartOptions={chartOptionsCreator}
              loading={isLoading}
            />
            {/* <MonthDropdown
              selectedMonth={selectedMonth}
              setSelectedMonth={setSelectedMonth}
            /> */}
          </div>
        </Col>
      </Row>
      <Row className="">
        <Col md={12}>
          <SubTitle text={"Pricing Plan"} classes="my-5" />
        </Col>

        {PricingLoading ? (
          <Col md={12}>
            <LoadingButton />
          </Col>
        ) : dataPricingPlan?.data?.length > 0 ? (
          dataPricingPlan?.data?.map((dt, idx) => (
            <Col key={idx} md={3} className="d-flex gap-3">
              <SubscribersBox dt={dt} refetch={refetchPricingPlan} />
            </Col>
          ))
        ) : (
          <Col md={12}>
            <p className="fs-7 text-white fw-normal">No Data Available</p>
          </Col>
        )}
      </Row>

      <Row>
        <Col md={12}>
          <SubTitle text={"Total Revenue"} classes="my-5" />
          <p className="fs-2 fw-bold text-white m-0">
            ${Number(editedData?.total_revenue ?? 0).toLocaleString()}
          </p>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <SubTitle text={"Attachments"} classes="my-5" />

          <div className={styles.mainTable}>
            <Table
              data={editedData?.attachments || []}
              columns={attachmentColumns}
              indication={() => "No Data available"}
            />
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <SubTitle text={"Subscribers"} classes="my-5" />

          <div className={styles.mainTable}>
            {<Table data={rowData} columns={columns} indication={indication} />}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CretorDetail;
